require("./agregatorConsentsWizard.scss");

// @vendors
import React from "react";
import PropTypes from "prop-types";
const { withRouter } = require('react-router-dom');
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
const { FormattedText } = require("core/i18n").i18n;

// @actions
import * as aggregatorConsentsActions from "actions/aggregator/aggregatorConsents";

// @constants
import { STATUS } from "../../../constants/aggregator/aggregatorConsents.constants";
import { CONTEXT_KEY } from 'constants/aggregator/aggregatorConsents.constants';

// @commons
const { LoadingSection } = require("commonsComponents/loadingSection");
import Wizard from "components/commons/wizard/wizard";
import WizardStep from "components/commons/wizardStep/wizardStep";
const OKSwitch = require("gdpr-consents/components/OKSwitch/OKSwitch");

// @components
import { AggregatorConsentsSignaturePattern } from "../aggregatorConsentsSignaturePattern/aggregatorConsentsSignaturePattern";

class AgregatorConsentsWizard extends React.Component {
    constructor(props) {
        super(props);
        this.cancel = this.cancel.bind(this);
    }

    cancel() {
        this.props.history.push("/myprofile/edit");
    }

    async validateStep(visibleStep) {
        const {
            getOTP,
        } = this.props.aggregatorConsentsActions;
        const { nextStep } = this.props.aggregatorConsentsActions;
        if (visibleStep < 2) {
            nextStep(visibleStep);
        }
        if (visibleStep === 1) {
            await getOTP();
        }
    }

    render() {
        const { immAggregatorChangeConsents } = this.props;
        const immFinalButton = "consents-finalButtonOTP";
        const {
            updateAggregatorConsents,
            previousStep,
            ownBusinessPurpousesChanged,
            thirdPartiesPurpousesChanged,
        } = this.props.aggregatorConsentsActions;
        const visibleStep = immAggregatorChangeConsents.get("visibleStep");
        const isFetching = immAggregatorChangeConsents.get("isFetching");
        const steps = immAggregatorChangeConsents.get("steps");
        const ownBusinessPurpouses = immAggregatorChangeConsents.get(
            "ownBusinessPurpouses"
        );
        const thirdPartiesPurpouses = immAggregatorChangeConsents.get(
            "thirdPartiesPurpouses"
        );
        const stepsAmount = steps.size;
        const ownBusinessPurpousesInfo =
            ownBusinessPurpouses === STATUS.ACCEPTED
                ? `${CONTEXT_KEY}-yes`
                : `${CONTEXT_KEY}-no`;
        const thirdPartiesPurpousesInfo =
            thirdPartiesPurpouses === STATUS.ACCEPTED
                ? `${CONTEXT_KEY}-yes`
                : `${CONTEXT_KEY}-no`;
        const actions = {
            finish: () => updateAggregatorConsents(ownBusinessPurpouses, thirdPartiesPurpouses),
            setWillCancel: () => {},
            cancel: this.cancel,
            setVisibleStep: () => previousStep(visibleStep),
            validateStep: async () => this.validateStep(visibleStep),
        };

        if (isFetching) {
            return <LoadingSection />;
        }

        return (
            <Wizard
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                showPreLeaveModal={true}
                actions={actions}
                onConfirmLeave={() => {}}
                immSteps={steps}
            >
                <WizardStep
                    position="first"
                    key={1}
                    cancelButton={true}
                    nextButtonDisabled={
                        ownBusinessPurpouses === STATUS.PENDING ||
                        thirdPartiesPurpouses === STATUS.PENDING
                    }
                    nextButtonCustomText={"Siguiente"}
                >
                    <div className="modify-aggregator-consent__steps-title">
                        <FormattedText
                            value={`${CONTEXT_KEY}-titleConsentFirstStep`}
                        />
                    </div>
                    <span className="box-separator" />
                    <p className="ok-section-box__paragraph">
                        <FormattedText
                            value={`${CONTEXT_KEY}-subtitleConsentFirstStep`}
                        />
                    </p>
                    <div className="modify-aggregator-consent">
                        <div className="modify-aggregator-consent__header"></div>

                        <div className="modify-aggregator-consent__content">
                            <div className="modify-aggregator-consent__content__switch">
                                <OKSwitch
                                    onChange={(e) =>
                                        ownBusinessPurpousesChanged(e)
                                    }
                                    positiveValue={STATUS.ACCEPTED}
                                    negativeValue={STATUS.NOT_ACCEPTED}
                                    neutralValue={STATUS.PENDING}
                                    value={ownBusinessPurpouses}
                                />
                            </div>
                            <div className="modify-aggregator-consent__content__body">
                                <h3 className="modify-aggregator-consent__content__body__title">
                                    <FormattedText
                                        value={`${CONTEXT_KEY}-firstSwitchTitle`}
                                    />
                                </h3>
                                <div className="modify-aggregator-consent__content__body__description">
                                    <FormattedText
                                        value={`${CONTEXT_KEY}-firstSwitchDescription`}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modify-aggregator-consent__content">
                            <div className="modify-aggregator-consent__content__switch">
                                <OKSwitch
                                    onChange={(e) =>
                                        thirdPartiesPurpousesChanged(e)
                                    }
                                    positiveValue={STATUS.ACCEPTED}
                                    negativeValue={STATUS.NOT_ACCEPTED}
                                    neutralValue={STATUS.PENDING}
                                    value={thirdPartiesPurpouses}
                                />
                            </div>
                            <div className="modify-aggregator-consent__content__body">
                                <h3 className="modify-aggregator-consent__content__body__title">
                                    <FormattedText
                                        value={`${CONTEXT_KEY}-secondSwitchTitle`}
                                    />
                                </h3>
                                <div className="modify-aggregator-consent__content__body__description">
                                    <FormattedText
                                        value={`${CONTEXT_KEY}-secondSwitchDescription`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </WizardStep>
                <WizardStep
                    position="last"
                    key={2}
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    <div className="modify-aggregator-consent__steps-title">
                        <FormattedText
                            value={`${CONTEXT_KEY}-titleConsentSecondStep`}
                        />
                    </div>
                    <div className="modify-aggregator-consent__steps-subtitle">
                        <FormattedText
                            value={`${CONTEXT_KEY}-subtitleConsentSecondStep`}
                        />
                    </div>
                    <p>
                        <FormattedText
                            value={`${CONTEXT_KEY}-firstParagraphTitleConsentSecondStep`}
                        />
                    </p>
                    <p className="title-success-bold">
                        <FormattedText value={ownBusinessPurpousesInfo} />
                    </p>
                    <p>
                        <FormattedText
                            value={`${CONTEXT_KEY}-secondParagraphTitleConsentSecondStep`}
                        />
                    </p>
                    <p className="title-success-bold">
                        <FormattedText value={thirdPartiesPurpousesInfo} />
                    </p>
                    <AggregatorConsentsSignaturePattern />
                </WizardStep>
            </Wizard>
        );
    }
}

AgregatorConsentsWizard.propTypes = {
    history: PropTypes.object.isRequired,
    immAggregatorChangeConsents: PropTypes.object,
    aggregatorConsentsActions: PropTypes.object,
};

AgregatorConsentsWizard.defaultProps = {
    immAggregatorChangeConsents: {},
    immSignaturePattern: {},
};
export default connect(
    (state) => ({
        immAggregatorChangeConsents: state.aggregatorChangeConsents,
        immSignaturePattern: state.signaturePattern,
    }),
    (dispatch) => ({
        aggregatorConsentsActions: bindActionCreators(
            aggregatorConsentsActions,
            dispatch
        ),
    })
)(withRouter(AgregatorConsentsWizard));
